<form #filterForm="ngForm">
  <div class="flex flex-wrap justify-start lg:justify-end gap-4">
   

    <!-- Date range picker -->
    <div class="flex flex-col w-full sm:w-auto">
      <p-datepicker
        [(ngModel)]="rangeDates"
        name="rangeDates"
        selectionMode="range"
        clearButtonStyleClass="bg-red right-4 ml-6 text-red"
        [inputStyle]="{
          border: 'none',
          paddingLeft: '0',
          paddingRight: '0',
          paddingTop: '0',
          paddingBottom: ''
        }"
        [styleClass]="
          'peer block px-0 pr-10 w-full text-sm text-gray-900 appearance-none border-0 border-b-2 focus:outline-none focus:ring-0 border-gray-300 focus:border-[#1f273b]'
        "
        (onSelect)="onDateChange()"
        (onClear)="onDateChange()"
        placeholder="Search by date"
        showClear="true"
      ></p-datepicker>
    </div>

   <!-- Filing Id + validation -->
<div class="flex flex-col w-full sm:w-auto">
  <input
    type="text"
    name="filingId"
    placeholder="Search by filing Id"
    [(ngModel)]="filingIdInput"
    #filingIdCtrl="ngModel"
    pattern="^[0-9]*$"

    (keydown)="preventSpaceKey($event)"
    (keydown.enter)="onSearch(filterForm)"
    (paste)="onPaste($event, 'filingIdInput')"

    class="text-sm border-b border-gray-400 focus:outline-none focus:border-[#001529]
           px-1 py-1.5 placeholder-gray-400 w-full sm:w-auto"
  />

  <small
    class="text-red-600 mt-1"
    *ngIf="filingIdCtrl.invalid && (filingIdCtrl.dirty || filingIdCtrl.touched)"
  >
    Filing ID must be an integer.
  </small>
</div>


    <!-- Issuer Name + error -->
    <div class="flex flex-col w-full sm:w-auto">
      <input
        type="text"
        name="issuerNameInput"
        placeholder="Search by issuer name"
        [(ngModel)]="issuerNameInput"
        #issuerNameCtrl="ngModel"
        (keydown.enter)="onSearch(filterForm)"
           (keydown)="preventSpaceKey($event)"
        (paste)="onPaste($event, 'issuerNameInput')"
        class="text-sm border-b border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1.5 placeholder-gray-400"
      />
    </div>

    <!-- Form Type -->
    <div class="flex flex-col w-full sm:w-auto">
      <select
        name="formType"
        [(ngModel)]="selectedFormType"
        (change)="onSearch(filterForm)"
        class="text-sm border-b border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1.5 placeholder-gray-400"
      >
        <option [ngValue]="undefined">Select form type</option>
        <option *ngFor="let type of formTypes" [ngValue]="type">
          {{ type }}
        </option>
      </select>
    </div>

    <!-- Follow-up Filter (same form, same onSearch) -->
    <div class="flex flex-col w-full sm:w-auto">
      <select
        name="followUpFilter"
        [(ngModel)]="followUpFilter"
        (change)="onSearch(filterForm)"
        class="text-sm border-b border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1.5 placeholder-gray-400"
      >
        <option *ngFor="let option of followUpOptions" [ngValue]="option">
          {{ option === 'all' ? 'Unprocessed Filing' : 'Follow-up Filing' }}
        </option>
      </select>
    </div>
  </div>
</form>

<div class="mb-4"></div>
<p-table
  (onLazyLoad)="loadData($event)"
  (onPage)="pageChange($event)"
  [first]="first"
  [lazy]="true"
  [loading]="isLoading"
  [paginator]="filings.length > 0"
  [rowsPerPageOptions]="[10, 25, 50]"
  [rows]="paginator.pageSize"
  [showCurrentPageReport]="true"
  [tableStyle]="{ 'min-width': '50rem' }"
  [totalRecords]="paginator.totalCount"
  [value]="filings"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
>
  <ng-template pTemplate="header">
    <tr>
      <th>Filing ID</th>
      <th>Form Type</th>
      <th>Accession Number</th>
      <th>Issuer Name</th>
      <th *ngIf="formState === 'TBD'">Follow up Comment</th>

      <th>Locked</th>
      <th>Trading Plan Count</th>
    </tr>
  </ng-template>
  <ng-template let-filing pTemplate="body">
    <tr>
      <td>
        <span
          (click)="
            filing.lockedBy && filing.lockedBy != thisUser
              ? null
              : openViewModal(filing, $event)
          "
          [style.color]="
            filing.lockedBy && filing.lockedBy != thisUser ? '#999' : '#4a90e2'
          "
          [style.cursor]="
            filing.lockedBy && filing.lockedBy != thisUser
              ? 'default'
              : 'pointer'
          "
          [style.text-decoration]="
            filing.lockedBy && filing.lockedBy != thisUser
              ? 'none'
              : 'underline'
          "
        >
          {{ filing.filingId }}
        </span>
      </td>
      <td>{{ filing.formType }}</td>
      <td>{{ filing.accessionNumber }}</td>
      <td>{{ filing.issuerName }}</td>
      <td *ngIf="formState === 'TBD'">{{ filing.followUpComment }}</td>

      <!--      <td>-->
      <!--        <a-->
      <!--          *ngIf="filing.sourceUrl"-->
      <!--          [href]="addProtocol(filing.sourceUrl)"-->
      <!--          rel="noopener noreferrer"-->
      <!--          style="color: #4a90e2; text-decoration: underline"-->
      <!--          target="_blank"-->
      <!--        >-->
      <!--          {{ filing.sourceUrl }}-->
      <!--        </a>-->
      <!--        <span *ngIf="!filing.sourceUrl">-</span>-->
      <!--      </td>-->

      <td>
        <i
          (click)="confirmUnlock(filing)"
          *ngIf="filing.lockedBy; else unlocked"
          class="pi pi-lock text-red-500"
          pTooltip="Locked by {{
            filing.lockedBy != thisUser ? filing.lockedBy : 'you.'
          }}"
          style="cursor: pointer"
          tooltipPosition="top"
        ></i>

        <ng-template #unlocked>
          <i
            (click)="lockFile(filing)"
            class="pi pi-unlock text-green-600"
            pTooltip="Click to edit"
            style="cursor: pointer"
            tooltipPosition="top"
          ></i>
        </ng-template>
      </td>
      <td>{{ filing.tradingPlanCount }}</td>
    </tr>
  </ng-template>
</p-table>
<ng-container *ngIf="!isLoading && filings.length === 0">
  <div class="text-center py-6 text-gray-500">No record found</div>
</ng-container>
<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
